import { InputField } from '../../../components/inputs/InputField'
import InputFileImg from '../../../components/inputs/InputFileImg'
import { Control, FieldValues, FormState } from 'react-hook-form'
import { inputRequiredRule } from '../../../helpers/form.helper'

interface FormFragmentTicketTextProps {
    formState: FormState<FieldValues>,
    control: Control<FieldValues, any>,
    attachmentsRequired?: boolean
}

export default function FormFragmentTicketText({ formState, control, attachmentsRequired }: Readonly<FormFragmentTicketTextProps>) {
    return (
        <div className='form-contain-row'>
            <div>
                <InputField
                    variant='standard'
                    controller={{
                        name: "description",
                        control: control,
                        defaultValue: "",
                        rules: { ...inputRequiredRule },
                    }}
                    errors={formState.errors}
                    label="Descripción*"
                    maxRows={4}
                    inputProps={{ maxLength: 3500 }}
                />
            </div>
            <div className='m-auto'>
                <InputFileImg
                    controller={{
                        name: `files`,
                        control: control,
                        defaultValue: "",
                        rules: attachmentsRequired ? { ...inputRequiredRule } : undefined,
                    }}
                    minSizeMb={0.05}
                    fileTypes="image/jpeg,image/jpg"
                    multiple
                    errors={formState.errors}
                    label={`Adjuntos*`}
                    icon={'image'}
                />
            </div>
        </div>
    )
}
